var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199219 2.33255C0.199219 1.15434 1.15434 0.199219 2.33255 0.199219H4.51871C5.15001 0.199219 5.71048 0.603183 5.91011 1.20209L6.90866 4.19771C7.13947 4.89014 6.826 5.64692 6.17317 5.97334L5.39634 6.36175C5.94824 7.27914 6.71929 8.0502 7.63669 8.6021L8.0251 7.82527C8.35152 7.17244 9.10829 6.85897 9.80073 7.08978L12.7964 8.08832C13.3953 8.28796 13.7992 8.84843 13.7992 9.47972V11.6659C13.7992 12.8441 12.8441 13.7992 11.6659 13.7992H10.9992C5.03454 13.7992 0.199219 8.96389 0.199219 2.99922V2.33255ZM2.33255 1.79922C2.038 1.79922 1.79922 2.038 1.79922 2.33255V2.99922C1.79922 8.08024 5.9182 12.1992 10.9992 12.1992H11.6659C11.9604 12.1992 12.1992 11.9604 12.1992 11.6659V9.57583L9.40447 8.64424L8.70376 10.0457C8.51175 10.4297 8.05082 10.5937 7.6594 10.4172C5.85173 9.60216 4.39628 8.14671 3.58126 6.33903C3.40478 5.94762 3.56875 5.48669 3.95279 5.29468L5.3542 4.59397L4.42261 1.79922H2.33255ZM4.39222 1.70805L4.39228 1.70824L4.39222 1.70805ZM5.39076 4.70368C5.39074 4.70362 5.39073 4.70356 5.39071 4.7035L5.39076 4.70368Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.647f60bcdb1eaa79fb15ebab9f148870.svg";
export { ForwardRef as ReactComponent };